import React from 'react';

export default function ({ width = '1.5em', height = '1.5em' } = {}) {
  return (
    <svg
      width={width}
      height={height}
      focusable="false"
      viewBox="0 0 24 24"
      aria-hidden="true"
      style={{
        fill: 'currentColor',
        display: 'inline-block',
        transition: 'fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        userSelect: 'none',
        flexShrink: 0,
      }}
    >
      <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"></path>
    </svg>
  );
}
